// API URL helpers

// Prefixes path with /api if not already prefixed
export function apiUrl(path) {
  if (!path || path.startsWith('/api/')) return path
  return `/api${path}`
}
